<template>
  <div class="value-sample">
    <div class="count">現在のカウント: {{ count }}</div>
    <button @click="decrement">減らす</button>
    <button @click="increment">増やす</button>
  </div>
</template>

<script>
import Vue from 'vue'
import { value } from 'vue-function-api'

export default {
  name: 'ValueSample',
  setup() {
    const count = value(0)
    const decrement = () => count.value--
    const increment = () => count.value++

    return {
      count,
      decrement,
      increment
    }
  }
}
</script>
